const e = "Appartementen", n = "Voor zaken", o = "Campings", s = "Met mijn partner", i = "Met familie", t = "Met vrienden", r = "Hotels", l = "Vakantieoorden", a = {
  "{num} reviews": "{num} beoordelingen",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} in {location}",
  "All languages": "Alle talen",
  "All traveler types": "Alle soorten reizigers",
  Apartments: e,
  "B&Bs": "B&B's",
  "based on {number} reviews": "gebaseerd op {number} beoordelingen",
  Business: n,
  Campsites: o,
  Couple: s,
  Family: i,
  Friend: t,
  "Highlighted reviews": "Gemarkeerde beoordelingen",
  Hotels: r,
  "No reviews found": "Geen beoordelingen gevonden",
  "Pet-friendly": "Huisdiervriendelijk",
  "Posted on {reviewer}": "Geplaatst op {reviewer}",
  "Read Reviews": "Recensies lezen",
  Resorts: l,
  "Review Summary": "Samenvatting van recensies",
  "Reviews by Source": "Beoordelingen per bron"
};
export {
  e as Apartments,
  n as Business,
  o as Campsites,
  s as Couple,
  i as Family,
  t as Friend,
  r as Hotels,
  l as Resorts,
  a as default
};
//# sourceMappingURL=nl.C3a7oDOZ.js.map
